import
  React
from 'react';

export default ({
  size = '49'
}) => (
  <svg
    fill="none"
    width={size}
    height={size}
    viewBox="0 0 39 49"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="#428600"
      d="M0 7.64706C0 3.4237 3.42371 0 7.64706 0H29.2444C32.3033 3.44118 34.7941 6.11769 39 10.3235V41.2941C39 45.5175 35.5763 48.9412 31.3529 48.9412H7.64706C3.4237 48.9412 0 45.5175 0 41.2941V7.64706Z"
    />
    <path
      fill="#A8B400"
      d="M32.9089 10.6175C30.4863 10.7145 28.535 8.6512 28.7671 6.23777L29.3494 0.183484L38.9862 10.374L32.9089 10.6175Z"
    />
    <path
      fill="#A8B400"
      d="M9.39404 23.0214L11.187 19.9393H12.8979L10.3198 24.1698L12.9565 28.4706H11.228L9.39404 25.3417L7.5542 28.4706H5.83154L8.47412 24.1698L5.89014 19.9393H7.60107L9.39404 23.0214ZM18.9683 24.8553H15.5347V28.4706H14.0522V19.9393H19.4722V21.1346H15.5347V23.6718H18.9683V24.8553ZM20.6499 28.4706V19.9393H23.1694C23.9233 19.9393 24.5913 20.1073 25.1733 20.4432C25.7593 20.7792 26.2124 21.2557 26.5327 21.8729C26.853 22.4901 27.0132 23.1971 27.0132 23.994V24.4218C27.0132 25.2303 26.8511 25.9413 26.5269 26.5546C26.2065 27.1678 25.7476 27.6405 25.1499 27.9725C24.5562 28.3046 23.8745 28.4706 23.105 28.4706H20.6499ZM22.1323 21.1346V27.287H23.0991C23.8765 27.287 24.4722 27.0448 24.8862 26.5604C25.3042 26.0721 25.5171 25.3729 25.5249 24.4628V23.9882C25.5249 23.0624 25.3237 22.3553 24.9214 21.8671C24.519 21.3788 23.9351 21.1346 23.1694 21.1346H22.1323ZM29.9722 27.287H33.8452V28.4706H28.4897V19.9393H29.9722V27.287Z"
    />
  </svg>
);